<template>
  <div class="submit-page">
      <section class="page-header">
        <h1>List Your Property</h1>
      </section>
      <div class="top-image">
      </div>


    <div class="content">
     <div class="submit-property">
       <div class="submit-inner">

         <template v-if="!formSubmitted">
            <p>If you’re interested in listing your property with us fill out the form below and we’ll get in touch with you.</p>
            <form ref="propertyform" @submit.prevent="formSubmit()">
              <div class="contact-info">
                <h3>Contact Information</h3>
                <label for="firstname">First Name</label>
                <input type="text" name="firstname" placeholder="First Name" required>
                <label for="lastname">Last Name</label>
                <input type="text" name="lastname" placeholder="Last Name" required>
                <label for="email">Email Address</label>
                <input type="email" name="email" placeholder="Email" required>
                <label for="phone">Phone Number</label>
                <input type="text" name="phone" placeholder="Phone" required>
                <label for="mobile">Mobile Number</label>
                <input type="text" name="mobile" placeholder="Mobile">
              </div>
              <div class="property-details">
                <h3>Property Details</h3>
                <label for="address">Address</label>
                <input type="text" name="address" placeholder="Address">
                <label for="city">City</label>
                <input type="text" name="city" placeholder="City">
                <label for="state">State</label>
                <select name="state" required>
                	<option value="" disabled selected hidden>Select a State</option>
                	<option value="AL">Alabama</option>
                	<option value="AK">Alaska</option>
                	<option value="AZ">Arizona</option>
                	<option value="AR">Arkansas</option>
                	<option value="CA">California</option>
                	<option value="CO">Colorado</option>
                	<option value="CT">Connecticut</option>
                	<option value="DE">Delaware</option>
                	<option value="DC">District Of Columbia</option>
                	<option value="FL">Florida</option>
                	<option value="GA">Georgia</option>
                	<option value="HI">Hawaii</option>
                	<option value="ID">Idaho</option>
                	<option value="IL">Illinois</option>
                	<option value="IN">Indiana</option>
                	<option value="IA">Iowa</option>
                	<option value="KS">Kansas</option>
                	<option value="KY">Kentucky</option>
                	<option value="LA">Louisiana</option>
                	<option value="ME">Maine</option>
                	<option value="MD">Maryland</option>
                	<option value="MA">Massachusetts</option>
                	<option value="MI">Michigan</option>
                	<option value="MN">Minnesota</option>
                	<option value="MS">Mississippi</option>
                	<option value="MO">Missouri</option>
                	<option value="MT">Montana</option>
                	<option value="NE">Nebraska</option>
                	<option value="NV">Nevada</option>
                	<option value="NH">New Hampshire</option>
                	<option value="NJ">New Jersey</option>
                	<option value="NM">New Mexico</option>
                	<option value="NY">New York</option>
                	<option value="NC">North Carolina</option>
                	<option value="ND">North Dakota</option>
                	<option value="OH">Ohio</option>
                	<option value="OK">Oklahoma</option>
                	<option value="OR">Oregon</option>
                	<option value="PA">Pennsylvania</option>
                	<option value="RI">Rhode Island</option>
                	<option value="SC">South Carolina</option>
                	<option value="SD">South Dakota</option>
                	<option value="TN">Tennessee</option>
                	<option value="TX">Texas</option>
                	<option value="UT">Utah</option>
                	<option value="VT">Vermont</option>
                	<option value="VA">Virginia</option>
                	<option value="WA">Washington</option>
                	<option value="WV">West Virginia</option>
                	<option value="WI">Wisconsin</option>
                	<option value="WY">Wyoming</option>
                </select>
                <label for="zip">Zip</label>
                <input type="text" name="zip" placeholder="Zip">
                <label>Have you had filming at this location before?</label>
                <div class="radios"><input type="radio" name="filmingbefore" value="yes" id="filmingyes"> <label for="filmingyes">Yes</label> <input type="radio" name="filmingbefore" value="no" id="filmingno"> <label for="filmingno">No</label></div>

              </div>

              <div class="additional-info">
                <h3>Additional Information</h3>
                <div class="photos">
                  <label>Property Photos (Please provide at least one)</label>
                  <div class="photo-upload">
                    <picture-input
                      ref="pictureInput1"
                      @change="photoUploadOne"
                      width="180"
                      height="180"
                      accept="image/jpeg,image/png"
                      size="5"
                      buttonClass="btn"
                    >
                    </picture-input>
                  </div>
                  <div class="photo-upload">
                    <picture-input
                      ref="pictureInput2"
                      @change="photoUploadTwo"
                      width="180"
                      height="180"
                      accept="image/jpeg,image/png"
                      size="5"
                      buttonClass="btn"
                    >
                    </picture-input>
                  </div>
                  <div class="photo-upload">
                    <picture-input
                      ref="pictureInput3"
                      @change="photoUploadThree"
                      width="180"
                      height="180"
                      accept="image/jpeg,image/png"
                      size="5"
                      buttonClass="btn"
                    >
                    </picture-input>
                  </div>
                </div>
                <label for="notes">Additional Information</label>
                <textarea name="notes" id="notes"></textarea>
              </div>

              <div ref="recaptcha" class="recaptcha"></div>

              <button type="submit" v-if="!formLoading">Submit Your Property</button>
              <button type="submit" v-else disabled="disabled">Sending..</button>
            </form>
         </template>
           <template v-else>
              <h1 class="received">Submission Received</h1>
              <p>Thank you! We'll get back to you as soon as possible.</p>
           </template>
       </div><!-- /.submit-inner -->
     </div><!-- /.submit -->

    <div class="bottom-section">
    </div>


    </div><!-- /.content -->

  </div><!-- /.about-page -->
</template>

<script>
import PictureInput from 'vue-picture-input'
export default {
  name: 'SubmitPropertyPage',
  components: {
    PictureInput
  },
  data () {
    return {
      image1: '',
      image2: '',
      image3: '',
      formSubmitted: false,
      formLoading: false,
      sitekey: '6Lfr0owsAAAAABp_7N0xVdXR4A-L2wHs5lXZKyzk',
      recaptchaToken: null,
      widgetId: null
    }
  },
  mounted () {
    const checkGrecaptcha = setInterval(() => {
      if (window.grecaptcha && window.grecaptcha.render) {
        clearInterval(checkGrecaptcha)
        console.log('captcha loaded')
        this.$nextTick(() => {
          try {
            console.log(this.$refs.recaptcha)
            this.renderCaptcha()
          } catch (e) {
            console.error('Render failed:', e)
          }
        })
      }
    }, 100)
  },
  created: function () {
    document.title = 'Property Submit - Production Locations'
    document.head.querySelector('meta[name=description]').content = 'List your home or business with Production Locations to get your property used as a location for Film, TV and Photo Shoots.'
  },
  methods: {
    renderCaptcha () {
      if (window.grecaptcha && this.$refs.recaptcha) {
        this.widgetId = window.grecaptcha.render(this.$refs.recaptcha, {
          'sitekey': '6Lfr0owsAAAAABp_7N0xVdXR4A-L2wHs5lXZKyzk',
          'callback': (token) => {
            this.recaptchaToken = token
          }
        })
      }
    },
    photoUploadOne (image) {
      if (image) {
        this.image1 = image
      }
    },
    photoUploadTwo (image) {
      if (image) {
        this.image2 = image
      }
    },
    photoUploadThree (image) {
      if (image) {
        this.image3 = image
      }
    },
    formSubmit () {
      if (!this.recaptchaToken) {
        alert('Please complete the reCAPTCHA')
        return
      }
      this.formLoading = true
      var formData = new FormData(this.$refs['propertyform'])
      if (this.$refs.pictureInput1.file) formData.append('image1', this.$refs.pictureInput1.file)
      if (this.$refs.pictureInput2.file) formData.append('image2', this.$refs.pictureInput2.file, 'image2')
      if (this.$refs.pictureInput3.file) formData.append('image3', this.$refs.pictureInput3.file, 'image3')
      this.$http.post(this.$root.apiurl + 'submitproperty', formData).then(response => {
        this.formSubmitted = true
      }, response => {
        console.log(response.statusText)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_mixins.scss";

.submit-property {
  background: #F3F3F3;
  padding: 4em 1em;
  @include bp(most) {
    padding: 6em 1em;
  }
  .submit-inner {
    max-width: 900px;
    margin: 0px auto;
  }
}

.bottom-section {
  background: $yellow;
  height: 8em;
  text-align: center;
  display: none;
  @include bp(most) {
    display: block;
  }
}

p {
  font-family: $noto;
  line-height: 1.5;
}

.contact-info {
  @include bp(most) {
    display: inline-block;
    vertical-align: top;
    width: 42%;
    margin-right: 15%;
  }
}
.property-details {
  @include bp(most) {
    display: inline-block;
    vertical-align: top;
    width: 42%;
  }
}

h3 {
  font-size: 1.75em;
  font-weight: 300;
  padding-bottom: .25em;
  border-bottom: 2px solid #979797;

}
  label {
    display: block;
    font-family: $noto;
    color: #8A8A8A;
    margin: .25em 0;
  }
  input[type=text], input[type=email] {
    font-family: $noto;
    display: block;
    text-align: left;
    width: 100%;
    outline: none;
    padding: .75em;
    font-size: 1em;
    box-sizing: border-box;
    margin-bottom: .75em;
    border: 1px solid #7D7D7D;
    border-radius: 3px;
    color: $notblack;
    background: #FBFBFB;
    &::placeholder {
      color: #CFCFCF;
    }
    &:focus {
      background: #FFF;
    }
  }
  select {
    font-family: $noto;
    display: block;
    text-align: left;
    width: 100%;
    outline: none;
    height: 3em;
    font-size: 1em;
    box-sizing: border-box;
    margin-bottom: .75em;
    border: 1px solid #7D7D7D;
    border-radius: 3px;
    color: $notblack;
    background: #FBFBFB;
    -webkit-appearance: none;
    padding-left: .75em;
    &:required:invalid {
      color: #CFCFCF;
    }
  }
  .radios {
    padding: .75em 0;
    input {
      display: inline-block;
    }
    label {
      display: inline-block;
      color: $notblack;
      margin-right: 1em;
    }
  }
  .photo-upload {
    width: 180px;
    height: 217px;
    margin-right: 1em;
    display: inline-block;
    vertical-align: top;
  }
  textarea {
    font-family: $noto;
    display: block;
    text-align: left;
    width: 100%;
    outline: none;
    padding: .75em;
    font-size: 1em;
    box-sizing: border-box;
    margin-bottom: .75em;
    border: 1px solid #7D7D7D;
    border-radius: 3px;
    color: $notblack;
    background-color: #FBFBFB;
    height: 10em;
    &:focus {
      background-color: #FFF;
    }
  }
  button {
    background: $blue;
    outline: none;
    border: 0px none;
    border-radius: 3px;
    font-family: $montserrat;
    color: #FFF;
    font-weight: 300;
    font-size: 1.25em;
    padding: .5em 1.5em;
    line-height: 1.4;
    &:disabled {
      background: #7d7d7d;
    }
  }
  h1.received {
    font-weight: 300;
    @include bp(most) {
      font-size: 36px;
    }
  }

  div.recaptcha {
    padding-bottom: 1em;
  }
</style>



// WEBPACK FOOTER //
// SubmitPropertyPage.vue?61600077